import { CarrierType, CarrierVisitDirection } from '@planning/app/api'
import { IFieldConfig } from '@planning/config/csvHeaderConfig'
import { FieldSchema } from 'csv-file-validator'

export type OptionalFieldSchemaParameters = {
  visitType: CarrierType
  handlingDirection: CarrierVisitDirection
  hasDoorDirection: boolean
  hasOperationalInstructions: boolean
  hasOrderVisitPosition: boolean
  hasUnitType: boolean
  hasReferenceNumber?: boolean
  hasOverLengthRear?: boolean
  hasOverLengthFront?: boolean
  hasOverWidthLeft?: boolean
  hasOverWidthRight?: boolean
  hasOverTop?: boolean
  hasOtherLabels?: boolean
  hasAtConsignee?: boolean
  hasCustomerName?: boolean
  hasPosition?: boolean
}

export const getTemplateOptionalFieldSchema = (
  visitType: CarrierType,
  handlingDirection: CarrierVisitDirection,
): IFieldConfig[] =>
  getOptionalFieldSchema({
    visitType,
    handlingDirection,
    hasDoorDirection: true,
    hasOperationalInstructions: true,
    hasOrderVisitPosition: true,
    hasUnitType: true,
    hasReferenceNumber: true,
    hasOverLengthRear: true,
    hasOverLengthFront: true,
    hasOverWidthLeft: true,
    hasOverWidthRight: true,
    hasOverTop: true,
    hasOtherLabels: true,
    hasAtConsignee: true,
    hasCustomerName: true,
    hasPosition: true,
  })

export const getOptionalFieldSchema = (
  optionalFieldSchemaParameters: OptionalFieldSchemaParameters,
) => {
  const fieldSchema: FieldSchema[] = []

  const {
    visitType,
    handlingDirection,
    hasDoorDirection,
    hasOperationalInstructions,
    hasOrderVisitPosition,
    hasUnitType,
    hasReferenceNumber,
    hasOverTop,
    hasOverLengthFront,
    hasOverLengthRear,
    hasOverWidthLeft,
    hasOverWidthRight,
    hasOtherLabels,
    hasCustomerName,
    hasPosition,
  } = optionalFieldSchemaParameters

  if (
    hasDoorDirection &&
    visitType === CarrierType.Train &&
    handlingDirection === CarrierVisitDirection.Outbound
  ) {
    fieldSchema.push({ name: 'DoorDirection', inputName: 'doorDirection' })
  }

  if (hasOperationalInstructions) {
    fieldSchema.push({ name: 'OperationalInstructions', inputName: 'operationalInstructions' })
  }

  if (hasUnitType) {
    fieldSchema.push({ name: 'UnitType', inputName: 'unitType' })
  }

  if (hasReferenceNumber) {
    fieldSchema.push({ name: 'Reference Number', inputName: 'referenceNumber' })
  }

  if (hasOverTop) {
    fieldSchema.push({ name: 'OverTop', inputName: 'overTop' })
  }

  if (hasOverLengthFront) {
    fieldSchema.push({ name: 'OverLengthFront', inputName: 'overLengthFront' })
  }

  if (hasOverLengthRear) {
    fieldSchema.push({ name: 'OverLengthRear', inputName: 'overLengthRear' })
  }

  if (hasOverWidthLeft) {
    fieldSchema.push({ name: 'OverWidthLeft', inputName: 'overWidthLeft' })
  }

  if (hasOverWidthRight) {
    fieldSchema.push({ name: 'OverWidthRight', inputName: 'overWidthRight' })
  }

  if (hasOtherLabels) {
    fieldSchema.push({ name: 'Other Labels', inputName: 'otherLabels' })
  }
  if (hasCustomerName) {
    fieldSchema.push({ name: 'Customer Name', inputName: 'customerName' })
  }
  if (hasPosition) {
    fieldSchema.push({ name: 'Position', inputName: 'position' })
  }

  if (visitType === CarrierType.Train) {
    if (handlingDirection === CarrierVisitDirection.Inbound || hasOrderVisitPosition) {
      fieldSchema.push(
        { name: 'Waggon', inputName: 'waggon' },
        { name: 'Sequence', inputName: 'sequence' },
        { name: 'Track', inputName: 'track' },
      )
    }
  }

  return fieldSchema
}
